import React from 'react'
import { NavLink } from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

const locations = [
  {
    image: require('./../../images/our-history/2.jpg'),
    title: 'Reduced construction time through modular systems',
    location: '',
    description:
      'Headquartered with regional operations across key construction markets, Askala Company for General Trading Limited partners with contractors, developers, and engineering firms to redefine construction possibilities through innovative formwork technology and slab systems – building the skyline of tomorrow, today.',
  },
]



class Projects3 extends React.Component {
  render() {
   
    return (
      <>
        <div className="section-full p-t60 p-b10 bg-white inner-page-padding">
          <div className="container">
            <div className="section-content ">
              <div className="our-history text-black">
                {locations.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col-12">
                      <div className="our-history-content m-b30">
                        <div className="large-title">
                          <h3 className="m-t0">{item.title}</h3>
                          <h4>{item.location}</h4>
                        </div>
                        <p>{item.description}</p>
                        {/* <NavLink
                          to={"/about-1"}
                          className="site-button-secondry btn-half"
                        >
                          <span> View All</span>
                        </NavLink> */}
                      </div>
                    </div>
                    <div className="col-12 pic-bg-border">
                      <div
                        className="our-history-pic bg-no-repeat bg-center bg-cover"
                        data-stellar-background-ratio="0.5"
                        style={{ backgroundImage: 'url(' + item.image + ')' }}
                      ></div>
                    </div>
                  </div>
                ))}
                {/* <div
                  className="text-center load-more-btn-outer"
                  style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <button
                    id="loadMorebtn-5"
                    className="site-button-secondry btn-half"
                  >
                    <span>Load More</span>
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Projects3
